import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import resources from './translations';
import store from '../../store';

const url = window.location.origin;

const languageSelector = () => {
    let urlLocaleParam = new URLSearchParams(window.location.search).get(
        'locale',
    );

    if (
        ['dev', 'stg'].includes(process.env.REACT_APP_STAGE) &&
        (['en-US', 'pt-BR', 'es-ES'].includes(localStorage.debug_locale) ||
            ['en-US', 'pt-BR', 'es-ES'].includes(urlLocaleParam))
    ) {
        localStorage.setItem(
            'i18nextLng',
            ['en-US', 'pt-BR', 'es-ES'].includes(urlLocaleParam)
                ? urlLocaleParam
                : localStorage.debug_locale,
        );

        return ['en-US', 'pt-BR', 'es-ES'].includes(urlLocaleParam)
            ? urlLocaleParam
            : localStorage.debug_locale;
    }

    let locale = url.includes('.br') ? 'pt-BR' : 'es-ES';

    localStorage.setItem('i18nextLng', locale);

    return locale;
};

i18n.use(initReactI18next).init({
    lng: languageSelector(),
    fallbackLng: 'es-ES',
    debug: false,
    resources,
});

export const locales = {
    pt: 'por',
    es: 'spa',
    en: 'eng',
};

export const getCurrentLang = () => {
    let currentLang = languageSelector();

    return currentLang.slice(0, currentLang.indexOf('-'));
};

export const getCurrentLocale = () => {
    return locales[getCurrentLang()];
};

const i18nInit = async () => {
    const startTime = Date.now();

    await new Promise(resolve => {
        const checkStateLoaded = () => {
            if (store?.getState() || Date.now() > startTime + 5000) {
                resolve();
            } else {
                setTimeout(checkStateLoaded, 150);
            }
        };

        checkStateLoaded();
    });

    const {translation} = store?.getState().config || {};

    let translationUrl = translation && translation[getCurrentLocale()];

    let translation_response = await fetch(
        translationUrl ||
            // eslint-disable-next-line max-len
            'https://cn.i.cdn.ti-platform.com/cnplus/translation/translation_es.json',
    )
        .then(res => res)

        .catch(err => (err.response ? err.response : err));

    if (translation_response && translation_response.status === 200) {
        translation_response = translation_response.json().then(res => {
            i18n.addResourceBundle(
                translationUrl ? getCurrentLang() : 'es',
                'translation',
                res,
                true,
                true,
            );
        });
    }
};

i18nInit();

export default i18n;
